/* istanbul ignore file */
import { Show } from 'framework/show';
import { ShowPageLayoutWithoutMenu, ShowSection } from 'framework/ui/layout';
import useNewCompetencyService from 'domain/people/career/qualification/newCompetency/newCompetencyService';
import { LinkField } from 'framework/ui/field';
import LinkIcon from '@mui/icons-material/LaunchOutlined';
import { Box, Typography } from '@mui/material';
import NewQualificationModel from 'domain/people/career/qualification/newCompetency/Show/NewQualificationModel';

const NewQualificationModelViewPage = () => {
  const { getCompetencies } = useNewCompetencyService();

  return (
    <Show getDataMethod={getCompetencies}>
      <ShowPageLayoutWithoutMenu>
        <Typography variant="h1" mb={5.25} color="brand">
          Syberry Qualification Model
        </Typography>
        {/* TODO: update link here after updating QM in policy and remove hidden prop */}
        <Box sx={{ marginBottom: '42px', a: { display: 'flex', alignItems: 'center' } }} hidden>
          <Typography variant="h2" color="brand" mb={2.25}>
            Policy
          </Typography>
          <LinkField
            linkText="Syberry Qualification Policy"
            isInternal={false}
            icon={LinkIcon}
            value="https://git.syberry.com/syberry-policies/production/-/blob/master/qualification-model.md"
          />
        </Box>
        <ShowSection title="Qualification requirements" titleVariant="h2">
          <NewQualificationModel />
        </ShowSection>
      </ShowPageLayoutWithoutMenu>
    </Show>
  );
};

export default NewQualificationModelViewPage;
